import MultipleSelect from './AllInvoice';
import { statusFilterSel } from 'src/store/modules/invoices';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
  statusFilter: statusFilterSel(state)
});
export default connect(mapStateToProps, null)(MultipleSelect);
